export const ConvertToCMSViewMode = (viewMode: string): string => {
  switch (viewMode.toUpperCase()) {
    case "DAILY": return "dailyHour";
    case "DAILYLIST": return "dailylist";
    case "WEEKLY": return "weeklybyday";
    case "MONTHLY": return "monthly";
    case "YEARLY": return "yearly";
    case "MONTHLYLIST": return "event";
    default: return "monthly";
  }
};

export const ConvertToStandardViewMode = (viewMode: string): string => {
  let standardViewMode = "";

  switch (viewMode.toUpperCase().trim()) {
    // Standard/new view modes:
    case "DAILY": standardViewMode = "DAILY"; break;
    case "DAILYLIST": standardViewMode = "DAILYLIST"; break;
    case "WEEKLY": standardViewMode = "WEEKLY"; break;
    case "MONTHLY": standardViewMode = "MONTHLY"; break;
    case "YEARLY": standardViewMode = "YEARLY"; break;
    case "MONTHLYLIST": standardViewMode = "MONTHLYLIST"; break;
    // Old CMS view Modes:
    case "DAILYHOUR": standardViewMode = "DAILY"; break;
    case "DAILYLIST": standardViewMode = "DAILYLIST"; break;
    case "WEEKLYHOUR": standardViewMode = "WEEKLY"; break;
    case "WEEKLYLIST": standardViewMode = "WEEKLY"; break;
    case "WEEKLYBYDAY": standardViewMode = "WEEKLY"; break;
    case "EVENT": standardViewMode = "MONTHLYLIST"; break;
    case "EVENTLIST": standardViewMode = "MONTHLYLIST"; break;
    default: standardViewMode = "MONTHLY";
  }

  return LimitToSupportedViewMode(standardViewMode);

};

export const LimitToSupportedViewMode = (viewMode: string): string => {
  const normalisedViewMode = viewMode.toUpperCase().trim();
  const supportedViewModes = ["DAILYLIST", "WEEKLY", "MONTHLY", "MONTHLYLIST"];

  if (supportedViewModes.indexOf(normalisedViewMode) !== -1) {
    return normalisedViewMode;
  } else {
    return "MONTHLY";
  }

};
